import { Component, OnDestroy, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatError, MatFormField, MatInput, MatPrefix } from '@angular/material/input';

import { AuthenticationService } from '@dangl/angular-dangl-identity-client';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'da-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardTitle, MatCardContent, FormsModule, MatFormField, MatPrefix, MatIcon, MatInput, MatError, MatButton]
})
export class LoginComponent implements OnDestroy {
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);

  showLoginError = signal(false);
  errorCount = signal(0);
  credentials = signal({
    identifier: null,
    password: null
  });
  requestEnRoute = signal(false);
  activeLocale: string;

  ngOnDestroy() {
    if (this.credentials()) {
      this.credentials.set({ identifier: null, password: null });
    }
  }

  login() {
    this.requestEnRoute.set(true);

    const credentials = this.credentials();
    this.authenticationService.loginWithToken(credentials.identifier, credentials.password).subscribe(r => {
      this.requestEnRoute.set(false);
      if (r) {
        this.showLoginError.set(false);
        this.errorCount.set(0);
        this.router.navigateByUrl('/');
      } else {
        this.showLoginError.set(true);
        this.errorCount.update(count => count + 1);
      }
    });
  }

  resetErrorDisplay() {
    this.showLoginError.set(false);
  }

  updateIdentifier(identifier: string) {
    this.credentials.update(value => ({ ...value, identifier }));
  }

  updatePassword(password: string) {
    this.credentials.update(value => ({ ...value, password }));
  }
}
